import { useState, useEffect } from 'react';
import { getProperties, submitInsight } from '../api';

function MarketInsights() {
    const [insights, setInsights] = useState([]);
    const [properties, setProperties] = useState([]);
    const [formData, setFormData] = useState({ propertyID: '', comment: '', rating: '', user: '' });
    const [error, setError] = useState('');

    useEffect(() => {
        getProperties()
            .then(data => {
                const propsWithInsights = data.filter(prop => prop.community_insights?.length > 0);
                setProperties(data);
                const allInsights = propsWithInsights.flatMap(prop =>
                    prop.community_insights.map(insight => ({
                        ...insight,
                        propertyID: prop.propertyID,
                        location: prop.location
                    }))
                );
                setInsights(allInsights);
            })
            .catch(err => setError('Failed to fetch insights'));
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await submitInsight(formData);
            setFormData({ propertyID: '', comment: '', rating: '', user: '' });
            const data = await getProperties();
            const propsWithInsights = data.filter(prop => prop.community_insights?.length > 0);
            setProperties(data);
            const allInsights = propsWithInsights.flatMap(prop =>
                prop.community_insights.map(insight => ({
                    ...insight,
                    propertyID: prop.propertyID,
                    location: prop.location
                }))
            );
            setInsights(allInsights);
        } catch (err) {
            setError(err.response?.data?.error || 'Failed to submit insight');
        }
    };

    return (
        <div className="p-4 bg-gray-100 rounded max-w-lg mx-auto">
            <h3 className="text-xl mb-4">Market Insights</h3>
            {error && <p className="text-red-500 mb-4">{error}</p>}
            <form onSubmit={handleSubmit} className="mb-6">
                <select
                    name="propertyID"
                    value={formData.propertyID}
                    onChange={e => setFormData({ ...formData, propertyID: e.target.value })}
                    className="border p-2 w-full mb-2"
                    required
                >
                    <option value="">Select Property</option>
                    {properties.map(prop => (
                        <option key={prop.propertyID} value={prop.propertyID}>{prop.location}</option>
                    ))}
                </select>
                <textarea
                    name="comment"
                    value={formData.comment}
                    onChange={e => setFormData({ ...formData, comment: e.target.value })}
                    placeholder="Your comment"
                    className="border p-2 w-full mb-2"
                    required
                />
                <input
                    type="number"
                    name="rating"
                    value={formData.rating}
                    onChange={e => setFormData({ ...formData, rating: e.target.value })}
                    placeholder="Rating (1-5)"
                    min="1"
                    max="5"
                    className="border p-2 w-full mb-2"
                    required
                />
                <input
                    type="text"
                    name="user"
                    value={formData.user}
                    onChange={e => setFormData({ ...formData, user: e.target.value })}
                    placeholder="Your name"
                    className="border p-2 w-full mb-2"
                    required
                />
                <button type="submit" className="bg-blue-500 text-white p-2 w-full">Submit Insight</button>
            </form>
            <h4 className="text-lg mb-2">Community Insights</h4>
            {insights.length === 0 && <p>No insights available.</p>}
            {insights.map((insight, index) => (
                <div key={index} className="border p-2 mb-2 rounded">
                    <p><strong>{insight.location}</strong> ({insight.propertyID})</p>
                    <p>{insight.comment} - {insight.user}</p>
                    <p>Rating: {insight.rating}/5</p>
                    <p>{new Date(insight.date).toLocaleDateString()}</p>
                </div>
            ))}
        </div>
    );
}

export default MarketInsights;